export default "__VITE_ASSET__u$hwptR___"